import moment from "moment";
import { ValidationResult } from "../search/criteria/validation/validationResult";

export const CAPACITY_MAX_MONTH_DIFF = 12;

export const getFurthestAllowedOppositeDate = (date, oppositeSelector) => {
	switch (oppositeSelector) {
		case "min":
			return moment(date)
				.subtract(CAPACITY_MAX_MONTH_DIFF, "months")
				.add(1, "days")
				.format("YYYY-MM-DD");

		case "max":
			return moment(date)
				.add(CAPACITY_MAX_MONTH_DIFF, "months")
				.subtract(1, "days")
				.format("YYYY-MM-DD");

		default:
			return date;
	}
};

export function capacityDateRangeCheck() {
	// explicitly showing the warning label at all times
	return ValidationResult.error(
		`Maximum allowed date range is ${CAPACITY_MAX_MONTH_DIFF} months`,
	);
}

export function filterCapacityDate(date, oppositeInput, oppositeSelector) {
	if (!oppositeInput || !oppositeSelector) {
		return true;
	}

	const { minMoment, maxMoment } = getFilterDateMinMaxValues(
		date,
		oppositeInput,
		oppositeSelector,
	);

	const monthDiff = Math.abs(minMoment.diff(maxMoment, "months"));

	return !(
		monthDiff > CAPACITY_MAX_MONTH_DIFF ||
		(monthDiff === CAPACITY_MAX_MONTH_DIFF &&
			maxMoment.get("date") > minMoment.get("date"))
	);
}

function getFilterDateMinMaxValues(date, oppositeInput, oppositeSelector) {
	const isOppositeMax = oppositeSelector === "max";

	return {
		minMoment: moment(isOppositeMax ? date : oppositeInput),
		maxMoment: moment(isOppositeMax ? oppositeInput : date),
	};
}

export function getNextWeekRange() {
	return {
		min: moment().add(1, "weeks").startOf("isoWeek").format("YYYY-MM-DD"),
		max: moment().add(1, "weeks").endOf("isoWeek").format("YYYY-MM-DD"),
	};
}
